import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import "./DashboardOverview.css";
const DashboardOverview = ({
  timeString,
  dateString,
  pendingTasks,
  missedTasks,
  completedTasks,
  graphFilter,
  setGraphFilter,
  getFilteredData,
  completionRate,
  totalTasks,
  nextDueTask,
  oldestOverdue,
  handleOpenTasks
}) => {
  return (
    <div className="dashboard-overview">
      <div className="welcome-banner-with-clock">
        <div className="welcome-banner">
          <h1>Dashboard Overview</h1>
          <p className="subtitle-text">System analytics and task distribution</p>
        </div>

        <div className="digital-clock-container">
            <div className="clock-time">{timeString}</div>
            <div className="clock-date">{dateString}</div>
          </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card pending">
          <div className="stat-strip-horizontal"></div>
          <div className="stat-data">
            <p className="stat-label">Pending Tasks</p>
            <h3 className="stat-value">{pendingTasks.length}</h3>
          </div>
        </div>
        <div className="stat-card missed">
          <div className="stat-strip-horizontal"></div>
          <div className="stat-data">
            <p className="stat-label">Overdue Tasks</p>
            <h3 className="stat-value">{missedTasks.length}</h3>
          </div>
        </div>
        <div className="stat-card completed">
          <div className="stat-strip-horizontal"></div>
          <div className="stat-data">
            <p className="stat-label">Completed Tasks</p>
            <h3 className="stat-value">{completedTasks.length}</h3>
          </div>

        </div>
      </div>


      <div className="insights-panel">
        <div className="insights-header">
          <div>
            <p className="insights-kicker">Focus zone</p>
            <h3>Quick insights</h3>
            <p className="insights-sub">Stay on top of what needs your attention today.</p>
          </div>
          <button className="insights-cta" onClick={handleOpenTasks}>Open tasks</button>
        </div>

        <div className="insights-grid">
          <div className="insight-card">
            <p className="insight-label">Next due task</p>
            <h4 className="insight-value">{nextDueTask ? nextDueTask.title : "No due task"}</h4>
            <p className="insight-meta">
              {nextDueTask?.due_date
                ? new Date(nextDueTask.due_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
                : "Set a due date to get reminders"}
            </p>
          </div>

          <div className="insight-card">
            <p className="insight-label">Completion rate</p>
            <h4 className="insight-value">{completionRate}%</h4>
            <div className="insight-progress">
              <div className="insight-progress-bar" style={{ width: `${completionRate}%` }} />
            </div>
            <p className="insight-meta">
              {completedTasks.length} of {totalTasks || 0} tasks done
            </p>
          </div>

          <div className="insight-card workload-card">
            <p className="insight-label">Workload split</p>
            <h4 className="insight-value">{totalTasks || 0} tasks</h4>
          </div>
        </div>
      </div>


      {/* --- TRADING STYLE ANALYTICS GRAPH --- */}
      {/* --- TRADING STYLE ANALYTICS GRAPH --- */}
      <div className="analytics-section-premium" style={{
        background: 'rgba(0, 10, 30, 0.4)',
        borderRadius: '20px',
        padding: '25px',
        marginTop: '30px',
        border: '1px solid rgba(0, 224, 255, 0.1)',
        boxShadow: '0 10px 40px rgba(0,0,0,0.4)',
        backdropFilter: 'blur(10px)',
        width: '100%'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div>
            <h4 style={{
          color: '#fff',
          margin: '0 0 15px 0',    // 👈 Teesra number (15px) niche space add karega
          fontSize: '16px',
          letterSpacing: '1px',
          fontWeight: '700'
        }}>
          CORE ANALYTICS
            </h4>

            {/* --- PREMIUM FILTER BAR --- */}
      <div style={{
        display: 'flex',
        gap: '10px',
        marginBottom: '20px',
        padding: '5px',
        background: 'rgba(255, 255, 255, 0.03)',
        borderRadius: '12px',
        width: 'fit-content'
      }}>
        {['Real-time', 'Weekly', 'Monthly', 'Archive'].map((filterType) => (
        <button
          key={filterType}
          onClick={() => setGraphFilter(filterType)} // 👈 Ab state update hogi
          style={{
            padding: '6px 15px',
            background: graphFilter === filterType ? 'rgba(0, 224, 255, 0.2)' : 'transparent',
            border: graphFilter === filterType ? '1px solid #00e0ff' : '1px solid transparent',
            color: graphFilter === filterType ? '#00e0ff' : 'rgba(255,255,255,0.5)',
            borderRadius: '8px',
            fontSize: '11px',
            fontWeight: '700',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            textTransform: 'uppercase'
          }}
        >
          {filterType}
        </button>
      ))}
      </div>
            <p style={{ color: '#00e0ff', fontSize: '10px', margin: 0, fontWeight: '800' }}>REAL-TIME SYSTEM METRICS</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <span style={{ color: '#00ff00', fontSize: '18px', fontWeight: 'bold' }}>LIVE</span>
            <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '10px', margin: 0 }}>DATA FEED</p>
          </div>
        </div>

        <div style={{ width: '100%', height: 320, minHeight: 320, display: 'flex', flexDirection: 'column' }}>
          <ResponsiveContainer width="100%" height={320}>
            <AreaChart data={getFilteredData()} margin={{ top: 10, right: 20, left: 30, bottom: 0 }}> {/* 👈 Increased left margin to 30 */}
              <defs>
                <linearGradient id="colorCount" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#00e0ff" stopOpacity={0.4}/>
                  <stop offset="95%" stopColor="#00e0ff" stopOpacity={0}/>
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
              <XAxis
                dataKey="name"
                axisLine={false}
                tickLine={false}
                tick={{fill: 'rgba(255,255,255,0.5)', fontSize: 10, fontWeight: 'bold'}}
                dy={10}
                interval={0}
              />
              <YAxis hide domain={[0, 'auto']} />
              <Tooltip
                contentStyle={{ background: '#001f3f', border: '1px solid #00e0ff', borderRadius: '8px', color: '#fff' }}
                itemStyle={{ color: '#00e0ff' }}
              />
              <Area
                type="monotone"
                dataKey="count"
                stroke="#00e0ff"
                strokeWidth={4}
                fillOpacity={1}
                fill="url(#colorCount)"
                animationDuration={1500}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default DashboardOverview;